import TimelineVertical from './TimelineVertical';
import TimelineCentered from './TimelineCentered';

const VARIANTS = {
  'timeline-vertical': TimelineVertical,
  'timeline-centered': TimelineCentered,
};

export default function TimelineSection({ section, data, theme, settings }) {
  const Variant = VARIANTS[section.variant] || TimelineVertical;
  return <Variant section={section} data={data} theme={theme} settings={settings} />;
}
